module.exports = __webpack_public_path__ + "img/user-no.14a7d9fb.png";